import { render, staticRenderFns } from "./inventorySyncRulesModal.vue?vue&type=template&id=0020ac9e&scoped=true"
import script from "./inventorySyncRulesModal.vue?vue&type=script&lang=js"
export * from "./inventorySyncRulesModal.vue?vue&type=script&lang=js"
import style0 from "./inventorySyncRulesModal.vue?vue&type=style&index=0&id=0020ac9e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0020ac9e",
  null
  
)

export default component.exports